import { Injectable, NgZone } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import * as io from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket: io.Socket;

  constructor() {
    const socketUri =
      location.hostname === 'localhost' || location.hostname.startsWith('172')
        ? `${location.hostname}:3000/`
        : `${location.hostname}/`;
    this.socket = io.connect(socketUri, { path: '/captionz-socket' });

    (window as any).socket = this.socket;
    this.socket.on('connect', () => {
      console.log('connected to socket server');
    });
  }

  joinRoom(videoId: string) {
    this.socket.emit('joinRoom', { videoId });
  }

  asyncSend(message: string, data = {}): Promise<any> {
    return new Promise((resolve) => {
      this.socket.emit(message, data, resolve);
    });
  }
}
